import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'lucide-react';
import { TranslatedCalling } from './common';

function UpdateImageTitleResult({ toolCall }: { toolCall: any }) {
  const { t } = useTranslation('chat');
  return (
    <div className="text-xs text-gray-400 font-light flex items-center gap-1">
      <CheckCircle className="w-3 h-3 text-green-600" />
      {t('tool.update-image-title.updated', {
        title: toolCall.result?.newTitle || t('tool.update-image-title.untitled'),
      })}
    </div>
  );
}

export const update_image_title = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.update-image-title.updating" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.update-image-title.updating-short" />,
  result: ({ toolCall }: any) => <UpdateImageTitleResult toolCall={toolCall} />,
};
